import React, { useMemo, useState, useEffect } from 'react';
import TableContainer from 'Common/TableContainer';
import { Link } from 'react-router-dom';
import { DashboardService } from '../../services/dashboardService';
import { Student } from '../../types/student';


const DashboardStudents = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<Student[]>([]);

    useEffect(() => {
        const loadStudents = async () => {
            try {
                setIsLoading(true);
                const recentStudents = await DashboardService.getRecentStudents();
                setData(recentStudents);
            } catch (error) {
                console.error('Error loading students:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadStudents();
    }, []);


    const columns = useMemo(() => [
        {
            header: "Student",
            accessorKey: "fullName",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cell: any) => (
                <div className="flex gap-2 items-center">
                    <div className="size-10 bg-green-100 rounded-full dark:bg-green-500/20 shrink-0">
                        <img src={cell.row.original.avatarUrl} alt="" className="h-10 rounded-full" onError={(e) => {
                            e.currentTarget.style.display = 'none';
                            const nextElement = e.currentTarget.nextElementSibling as HTMLElement;
                            if (nextElement) nextElement.style.display = 'flex';
                        }} />
                        <div className="size-10 bg-gray-100 rounded-full dark:bg-gray-500/20 shrink-0 items-center justify-center hidden" style={{display: 'none'}}>
                            <span className="text-gray-500">👤</span>
                        </div>
                    </div>
                    <div className="grow">
                        <h6 className="flex items-center h-full">{cell.getValue()}</h6>
                    </div>
                </div>
            ),
        },
        {
            header: "Username",
            accessorKey: "userName",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cell: any) => (
                <span>@{cell.getValue()}</span>
            ),
        },
        {
            header: "Email",
            accessorKey: "email",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Status",
            accessorKey: "deleted",
            enableColumnFilter: false,
            enableSorting: true,
            cell: (cell: any) => (
                cell.getValue() ?
                    <span className="px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-red-100 border-red-200 text-red-500 dark:bg-red-500/20 dark:border-red-500/20">Deactivated</span> :
                    <span className="px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-green-100 border-green-200 text-green-500 dark:bg-green-500/20 dark:border-green-500/20">Active</span>
            ),
        }
    ], []
    );

    return (
        <React.Fragment>
            <div className="col-span-12 order-5 md:order-8 2xl:col-span-12 card">
                <div className="card-body">
                    <div className="flex items-center justify-between gap-3 mb-5">
                        <div>
                            <h6 className="text-13 md:text-15">Most Recent Students</h6>
                        </div>
                        <div className="flex gap-2 md:gap-3 justify-end shrink-0">
                            <Link to="/students" className="text-white btn text-xs md:text-sm px-2 md:px-4 py-1.5 md:py-2 bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                View all
                            </Link>
                        </div>
                    </div>
                    {isLoading ? (
                        <div className="flex items-center justify-center h-32">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                        </div>
                    ) : (
                        <TableContainer
                            isPagination={false}
                            columns={(columns || [])}
                            data={(data || [])}
                            customPageSize={5}
                            divclassName="-mx-5 overflow-x-auto"
                            tableclassName="w-full whitespace-nowrap"
                            theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                            thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500 w-10"
                            tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-t border-slate-200 dark:border-zink-500 last:border-b-0"
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default DashboardStudents;
